import { useRouteMatch } from 'react-router';

import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { Heading, Scroll } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { referralTranslationKeys } from '../translations';

import { ReferralToSpecialistForm } from './ReferralToSpecialistForm/ReferralToSpecialistForm';
import { ReferralToSpecialistPanelLoader } from './ReferralToSpecialistPanel.loader';
import { ReferralToSpecialistRouteLeavingGuard } from './ReferralToSpecialistRouteLeavingGuard';
import { ElectronicReferralToSpecialistSendAction } from './ReferralToSpecialistSendAction/ElectronicReferralToSpecialistSendAction';
import { ReferralToSpecialistSendAction } from './ReferralToSpecialistSendAction/ReferralToSpecialistSendAction';

type ReferralToSpecialistPanelProps = {
   readonly visit: Visit;
};

export const ReferralToSpecialistPanel = (props: ReferralToSpecialistPanelProps): JSX.Element => {
   const electronic = Boolean(useRouteMatch({ path: visitPaths.ELECTRONIC_REFERRAL_TO_SPECIALIST_PATH }));

   return (
      <Scroll testId={'referralToSpecialist'}>
         <ReferralToSpecialistPanelLoader visitId={props.visit.id} electronic={electronic}>
            {({ referralToSpecialistDraft }) => (
               <>
                  <Heading
                     type={'h1'}
                     testId={'specialist'}
                     content={
                        electronic
                           ? referralTranslationKeys.referralType.SPECIALIST_ELECTRONIC
                           : referralTranslationKeys.referralType.SPECIALIST
                     }
                  />
                  <ReferralToSpecialistForm
                     referralToSpecialistDraft={referralToSpecialistDraft}
                     visitDiagnoses={props.visit.diagnoses}
                     visitBeginDate={props.visit.beginDate}
                  >
                     {({ handleSubmit, handleSubmitDraft, formState, reset, trigger }) => (
                        <>
                           {electronic ? (
                              <ElectronicReferralToSpecialistSendAction
                                 visitId={props.visit.id}
                                 patientId={props.visit.patient.id}
                                 handleSubmit={handleSubmit}
                                 onSuccess={reset}
                                 trigger={trigger}
                              />
                           ) : (
                              <ReferralToSpecialistSendAction
                                 visitId={props.visit.id}
                                 handleSubmit={handleSubmit}
                                 onSuccess={reset}
                              />
                           )}

                           <ReferralToSpecialistRouteLeavingGuard
                              formState={formState}
                              visitId={props.visit.id}
                              handleSubmitDraft={handleSubmitDraft}
                              electronic={electronic}
                           />
                        </>
                     )}
                  </ReferralToSpecialistForm>
               </>
            )}
         </ReferralToSpecialistPanelLoader>
      </Scroll>
   );
};
